import { CALL_API } from '../../../middleware/api';
import * as ActionTypes from '../promocodeAction';
export function promoCodeActivate(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.FETCH_PROMOCODE_ACTIVATE
            },
            _a[CALL_API] = {
                endpoint: "/api/gambler/activate-promocode",
                method: 'post',
                types: [ActionTypes.SUCCESS_FETCH_PROMOCODE_ACTIVATE, ActionTypes.FAILURE_FETCH_PROMOCODE_ACTIVATE],
                credentials: true,
                data: data
            },
            _a));
    };
}



// WEBPACK FOOTER //
// ./src/actions/promoCode/creators/promocodeAction.js